













































































































import rest from "@/rest";
import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ManageSubtitles from "../ContentCreator/ManageSubtitles.vue";
import { ElementSaveStateVm, ExChoiceList } from "@/interfaces/ExDataSet";
import { SubtitelVm } from "@/interfaces/SubtitelVm";

interface SubtitleCue {
  startTime: number;
  endTime: number;
  text: string;
}

const globals = namespace("globals");
const quizplayerstore = namespace("quizplayerstore");

@Component({
  name: 'CompBlock',
  components: {
    ManageSubtitles
  }
})
export default class CompAudioPlayerWithSubtitles extends Vue {
  @Prop() guid!: string;
  @Prop() choiceList!: ExChoiceList;
  @Prop() finalized!: boolean;
  @Prop({ required: true }) private src!: string;
  @Prop() compSettings!: string;

  @Prop({ default: false }) private allowSubtitleUpload!: boolean;
  @Prop({ default: false }) private preventSeeking!: boolean; // Used by settings component
  @Prop({ default: false }) private showManageSubtitles!: boolean;
  @Prop() private ccCreatedWithAi!: boolean; // Used by settings component of Content Creator
  @Prop({ default: null }) private title!: string; // Used by element component

  // Refs mit Decorator
  @Ref("audioPlayer") readonly audioPlayer!: HTMLAudioElement;
  @Ref("subtitleTrack") readonly subtitleTrack!: HTMLTrackElement;

  @quizplayerstore.Action setElementState!: (saveState: ElementSaveStateVm) => void;
  @quizplayerstore.Action getElementState!: (settings: string) => Promise<string | null>;

  // Data properties
  private settings: any = null;
  private subtitleText: string = "";
  private cues: SubtitleCue[] = [];
  private activeCueIndex: number | null = null;
  private subtitleObjectUrl: string | null = null;
  private subtitelFiles: SubtitelVm[] = [];
  private selectedSubtitle: SubtitelVm | null = null;
  private showManageSubtitlesDlg: boolean = false;
  private subtitleFile: File | null = null;
  private lastTime: number = 0;

  // Lifecycle hooks
  async mounted(): Promise<void> {
    // Parse component settings
    if (this.compSettings) {
      this.settings = JSON.parse(this.compSettings);
    }

    // Try to load existing state for this element
    if (this.choiceList?.items) {
      let saveState = await this.getElementState(this.guid);
      if (saveState && saveState == "1") {
        // Disable preventSeeking if already played once
        this.settings.preventSeeking = false;
      }
    }

    await this.loadSubtitles();

    // Setze initialen Subtitle, falls vorhanden
    if (this.subtitelFiles.length > 0) {
      this.selectedSubtitle = this.subtitelFiles[0];
    } else {
      this.selectedSubtitle = null;
    }

    // Parse cues as soon as the component is mounted
    await this.$globalHelper.delay(300); // Give time for track to load
    this.parseCues();
  }

  beforeDestroy(): void {
    // cleanup URL-Objekte if any
    if (this.subtitleObjectUrl) {
      URL.revokeObjectURL(this.subtitleObjectUrl);
    }
  }

  onTimeUpdate(e: Event) {
    const audio = e.target as HTMLAudioElement;
    // console.log("Timeupdate event", audio.currentTime);
    if (this.getPreventSeeking) {
      if (this.audioPlayer.currentTime > this.lastTime + 0.5) {
        this.audioPlayer.currentTime = this.lastTime;
      } else if (this.audioPlayer.currentTime > this.lastTime) {
        this.lastTime = this.audioPlayer.currentTime;
      }
    }

    this.updateSubtitle();
  }

  private onAudioEnded() {
    console.log("Audio ended");
    if (this.finalized || !this.choiceList || !this.getPreventSeeking) return;

    this.setElementState( {
        guid: this.guid,
        settings: "1"
      } as ElementSaveStateVm
    );

    // Enable "Weiter" button if preventSeeking is active
    this.$store.commit("quizplayerstore/setChoiceState",
      { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: true, selectionLable: "" }
    );
  }

  // Settings with priority over props
  get audioTitle(): string {
    if (this.title)
      return this.title;

    return this.settings?.title || "";
  }

  get enableDownload(): string {
    let enabled = this.settings?.enableDownload || false;
    return enabled ? "" : "nodownload";
  }

  get getPreventSeeking() {
    if (this.settings?.preventSeeking)
      return this.settings.preventSeeking;

    return this.preventSeeking;
  }

  get aiCreated() {
    if (this.ccCreatedWithAi !== undefined && this.ccCreatedWithAi !== null)
      return this.ccCreatedWithAi;
    return this.settings?.createdWithAi ?? false;
  }

  get playOnLoad() {
    if (this.settings?.playOnLoad)
      return this.settings.playOnLoad;

    // return this.playOnLoad;
    return false; // Play on load only if shown in quiz player
  }

  async loadSubtitles() {
    if (!this.src) return;
    console.log("Loading subtitles...");
    this.subtitelFiles = await rest.url("exercises/getSubtitles").query({ audioFile: this.src }).get();
    // Add element no subtitle
    this.subtitelFiles.unshift({
      label: "Keine Untertitel",
      source: "",
      languageCode: ""
    });
  }

  getAudioType(fileName: string): string {
    const extension = fileName.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "mp3":
        return "audio/mpeg";
      case "ogg":
        return "audio/ogg";
      case "wav":
        return "audio/wav";
      default:
        return "audio/mpeg";
    }
  }

  // Methods
  private updateSubtitle(): void {
    // console.log("Updating subtitle. cues length: ", this.cues.length);
    if (this.cues.length === 0) {
      return;
    }

    const currentTime = this.audioPlayer.currentTime;
    let text = "";

    // Finde den aktiven Cue basierend auf der aktuellen Zeit
    for (let i = 0; i < this.cues.length; i++) {
      const cue = this.cues[i];
      if (currentTime >= cue.startTime && currentTime <= cue.endTime) {
        text = cue.text;
        this.activeCueIndex = i;
        break;
      }
    }

    this.subtitleText = text;
    // console.log("Current subtitle text:", this.subtitleText);
  }

  private parseCues(): void {
    if (this.selectedSubtitle == null || !this.selectedSubtitle.languageCode) return;

    if (this.subtitleTrack && this.subtitleTrack.track) {
      console.log(`Parsing cues for ${this.selectedSubtitle?.label} ...`);
      const track = this.subtitleTrack.track;
      const tryLoadCues = (retries = 10) => {
        if (track.cues && track.cues.length > 0) {
          console.log("Cues loaded:", track.cues.length);
          this.cues = Array.from(track.cues).map((cue) => ({
            startTime: cue.startTime,
            endTime: cue.endTime,
            text: (cue as VTTCue).text,
          }));
        } else if (retries > 0) {
          console.warn("Warte auf Cues...", retries);
          setTimeout(() => tryLoadCues(retries - 1), 200);
        } else {
          console.warn("Keine Cues geladen.");
        }
      };
      tryLoadCues();
    }
  }

  private async handleSubtitleUpload(): Promise<void> {
    console.log("Handling subtitle upload...");
    if (!this.subtitleFile) return;

    try {
      if (this.subtitleObjectUrl) {
        URL.revokeObjectURL(this.subtitleObjectUrl);
      }

      const subtitleUrl = URL.createObjectURL(this.subtitleFile);

      // save for later cleanup
      this.subtitleObjectUrl = subtitleUrl;

      // set new subtitle source
      this.$nextTick(() => {
        // remove old track if available
        const oldTracks = this.audioPlayer.getElementsByTagName("track");
        while (oldTracks[0]) {
          oldTracks[0].remove();
        }

        // Erstelle neuen Track
        const track = document.createElement("track");
        track.kind = "subtitles";
        track.src = subtitleUrl;
        track.srclang = "de"; // TODO: Make configurable
        track.label = this.getFileName(this.subtitleFile!.name);
        track.default = true;

        // Füge den Track zum Audio-Element hinzu
        this.audioPlayer.appendChild(track);

        // Parse die neuen Cues (mit Timeout für Ladezeit)
        setTimeout(() => {
          // Da wir den Track manuell erstellt haben, müssen wir auf die Cues zugreifen
          const textTrack = this.audioPlayer.textTracks[0];
          if (textTrack) {
            const loadNewCues = () => {
              if (textTrack.cues) {
                this.cues = Array.from(textTrack.cues).map((cue) => ({
                  startTime: cue.startTime,
                  endTime: cue.endTime,
                  text:  (cue as VTTCue).text,
                }));
              }
            };

            if (textTrack.cues) {
              loadNewCues();
            } else {
              textTrack.addEventListener("load", loadNewCues);
            }
          }
        }, 100);
      });
    } catch (error) {
      console.error("Fehler beim Laden der Untertitel:", error);
    }
  }

  onSubtitleSelect() {
    console.log("Subtitle selected:", this.selectedSubtitle?.label);
    // Track neu parsen, wenn Auswahl geändert wurde
    this.$nextTick(() => {
      setTimeout(() => {
        this.parseCues();
      }, 200);
    });
  }

  private getFileName(fullName: string): string {
    return fullName.split(".")[0];
  }
}
